/* ==========================================================================
   ONDÉE — comportements du thème
   Vanilla JS, sans dépendance. Chaque module est autonome et silencieux
   si son marqueur HTML n'est pas présent sur la page.
   ========================================================================== */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ------------------------------------------------------------------
     Formatage monétaire (reprend le format de la boutique)
     ------------------------------------------------------------------ */
  function formatMoney(cents) {
    var format = window.themeMoneyFormat || '{{amount_with_comma_separator}} €';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var entiers = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    if (format.indexOf('amount_with_comma_separator') > -1 || format.indexOf('amount_no_decimals_with_comma_separator') > -1) {
      value = entiers + ',' + parts[1];
    } else {
      value = entiers.replace(/ /g, ',') + '.' + parts[1];
    }
    if (format.indexOf('no_decimals') > -1) value = value.split(/[.,]/)[0];

    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ------------------------------------------------------------------
     1. Tiroir de navigation mobile
     ------------------------------------------------------------------ */
  function initTiroir() {
    var tiroir = $('[data-tiroir]');
    var voile = $('[data-voile]');
    if (!tiroir) return;

    function basculer(ouvert) {
      tiroir.setAttribute('data-ouvert', ouvert);
      if (voile) voile.setAttribute('data-ouvert', ouvert);
      document.body.style.overflow = ouvert ? 'hidden' : '';
      $$('[data-ouvre-tiroir]').forEach(function (b) { b.setAttribute('aria-expanded', ouvert); });
    }

    $$('[data-ouvre-tiroir]').forEach(function (b) {
      b.addEventListener('click', function () { basculer(true); });
    });
    $$('[data-ferme-tiroir]').forEach(function (b) {
      b.addEventListener('click', function () { basculer(false); });
    });
    if (voile) voile.addEventListener('click', function () { basculer(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') basculer(false);
    });
  }

  /* ------------------------------------------------------------------
     2. Accordéons
     ------------------------------------------------------------------ */
  function initAccordeons() {
    $$('.accordeon').forEach(function (acc) {
      var bouton = $('.accordeon__bouton', acc);
      if (!bouton) return;
      bouton.addEventListener('click', function () {
        var ouvert = acc.getAttribute('data-ouvert') === 'true';
        acc.setAttribute('data-ouvert', String(!ouvert));
        bouton.setAttribute('aria-expanded', String(!ouvert));
      });
    });
  }

  /* ------------------------------------------------------------------
     3. Modales (guide des tailles, entretien…)
     ------------------------------------------------------------------ */
  function initModales() {
    $$('[data-ouvre-modale]').forEach(function (declencheur) {
      declencheur.addEventListener('click', function (e) {
        e.preventDefault();
        var cible = document.getElementById(declencheur.getAttribute('data-ouvre-modale'));
        if (!cible) return;
        cible.setAttribute('data-ouvert', 'true');
        document.body.style.overflow = 'hidden';
        var fermer = $('.modale__fermer', cible);
        if (fermer) fermer.focus();
      });
    });

    $$('.modale').forEach(function (modale) {
      function fermerModale() {
        modale.setAttribute('data-ouvert', 'false');
        document.body.style.overflow = '';
      }
      $$('[data-ferme-modale], .modale__fond', modale).forEach(function (el) {
        el.addEventListener('click', fermerModale);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modale.getAttribute('data-ouvert') === 'true') fermerModale();
      });
    });
  }

  /* ------------------------------------------------------------------
     4. Sélecteur de quantité
     ------------------------------------------------------------------ */
  function initQuantite() {
    $$('.quantite').forEach(function (bloc) {
      var champ = $('input', bloc);
      if (!champ) return;
      $$('button', bloc).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var pas = btn.getAttribute('data-sens') === 'plus' ? 1 : -1;
          var min = parseInt(champ.min || '1', 10);
          var valeur = parseInt(champ.value || '1', 10) + pas;
          champ.value = Math.max(min, valeur);
          champ.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     5. Fiche produit : variantes, prix, disponibilité
     ------------------------------------------------------------------ */
  function initProduit() {
    var fiche = $('[data-fiche-produit]');
    if (!fiche) return;

    /* Le JSON des variantes est rendu en fin de section, hors du bloc .produit */
    var script = $('[data-variantes]');
    if (!script) return;

    var variantes;
    try { variantes = JSON.parse(script.textContent); } catch (e) { return; }

    var champVariante = $('[data-id-variante]', fiche);
    var boutonAjout = $('[data-bouton-ajout]', fiche);
    var libelleAjout = $('[data-libelle-ajout]', fiche);
    var zonePrix = $('[data-zone-prix]', fiche);
    var zoneStock = $('[data-zone-stock]', fiche);
    var paiementRapide = $('[data-paiement-rapide]', fiche);
    var seuilBas = parseInt(fiche.getAttribute('data-seuil-stock') || '6', 10);

    function optionsChoisies() {
      return $$('[data-groupe-option]', fiche).map(function (groupe) {
        var coche = $('input:checked', groupe);
        return coche ? coche.value : null;
      });
    }

    function trouverVariante(choix) {
      for (var i = 0; i < variantes.length; i++) {
        var v = variantes[i];
        var ok = true;
        for (var j = 0; j < choix.length; j++) {
          if (choix[j] !== null && v.options[j] !== choix[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    /* Grise les valeurs d'option qui n'existent dans aucune variante disponible */
    function majDisponibilite(choix) {
      $$('[data-groupe-option]', fiche).forEach(function (groupe, index) {
        $$('input', groupe).forEach(function (entree) {
          var essai = choix.slice();
          essai[index] = entree.value;
          var correspond = variantes.filter(function (v) {
            for (var j = 0; j < essai.length; j++) {
              if (j !== index && essai[j] !== null && v.options[j] !== essai[j]) return false;
            }
            return v.options[index] === entree.value;
          });
          var dispo = correspond.some(function (v) { return v.available; });
          var puce = entree.nextElementSibling;
          if (puce) puce.setAttribute('data-indisponible', String(!dispo));
        });
      });
    }

    function majAffichage() {
      var choix = optionsChoisies();
      majDisponibilite(choix);

      var variante = trouverVariante(choix);

      /* Libellé de l'option sélectionnée */
      $$('[data-groupe-option]', fiche).forEach(function (groupe) {
        var coche = $('input:checked', groupe);
        var sortie = $('[data-valeur-option]', groupe.closest('.option') || groupe);
        if (sortie && coche) sortie.textContent = coche.value;
      });

      if (!variante) {
        if (boutonAjout) boutonAjout.setAttribute('disabled', 'disabled');
        if (libelleAjout) libelleAjout.textContent = fiche.getAttribute('data-texte-indisponible') || 'Indisponible';
        if (paiementRapide) paiementRapide.style.display = 'none';
        return;
      }

      if (champVariante) champVariante.value = variante.id;

      /* Prix */
      if (zonePrix) {
        var html = '';
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          html += '<span>' + formatMoney(variante.price) + '</span>';
          html += '<del>' + formatMoney(variante.compare_at_price) + '</del>';
          html += '<span class="badge-promo">' + fiche.getAttribute('data-texte-promo') + '</span>';
        } else {
          html += '<span>' + formatMoney(variante.price) + '</span>';
        }
        zonePrix.innerHTML = html;
      }

      /* Disponibilité */
      if (zoneStock) {
        var classe = 'stock';
        var texte;
        if (!variante.available) {
          classe += ' stock--rupture';
          texte = fiche.getAttribute('data-texte-rupture');
        } else if (variante.inventory_management && variante.inventory_quantity > 0 && variante.inventory_quantity <= seuilBas) {
          classe += ' stock--bas';
          texte = (fiche.getAttribute('data-texte-stock-bas') || '').replace('[n]', variante.inventory_quantity);
        } else {
          texte = fiche.getAttribute('data-texte-dispo');
        }
        zoneStock.className = classe;
        zoneStock.innerHTML = '<span class="stock__point"></span><span>' + texte + '</span>';
      }

      /* Bouton */
      if (boutonAjout) {
        if (variante.available) {
          boutonAjout.removeAttribute('disabled');
          if (libelleAjout) libelleAjout.textContent = fiche.getAttribute('data-texte-ajout');
          if (paiementRapide) paiementRapide.style.display = '';
        } else {
          boutonAjout.setAttribute('disabled', 'disabled');
          if (libelleAjout) libelleAjout.textContent = fiche.getAttribute('data-texte-rupture');
          if (paiementRapide) paiementRapide.style.display = 'none';
        }
      }

      /* Barre d'achat mobile */
      var barrePrix = $('[data-barre-prix]');
      if (barrePrix) barrePrix.textContent = formatMoney(variante.price);

      /* URL propre, sans rechargement */
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variante.id);
        history.replaceState({}, '', url.toString());
      }

      /* Image liée à la variante */
      if (variante.featured_media && variante.featured_media.id) {
        var cible = $('[data-media-id="' + variante.featured_media.id + '"]');
        var galerie = $('.galerie');
        if (cible && galerie && window.matchMedia('(max-width: 749px)').matches) {
          galerie.scrollTo({ left: cible.offsetLeft - galerie.offsetLeft, behavior: 'smooth' });
        } else if (cible) {
          cible.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }

    $$('[data-groupe-option] input', fiche).forEach(function (entree) {
      entree.addEventListener('change', majAffichage);
    });

    majAffichage();
  }

  /* ------------------------------------------------------------------
     6. Barre d'achat collante (mobile)
     ------------------------------------------------------------------ */
  function initBarreAchat() {
    var barre = $('[data-barre-achat]');
    var repere = $('[data-repere-achat]');
    if (!barre || !repere || !('IntersectionObserver' in window)) return;

    var observateur = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (entree) {
        barre.setAttribute('data-visible', String(!entree.isIntersecting));
      });
    }, { rootMargin: '0px 0px -120px 0px' });

    observateur.observe(repere);

    var lienBarre = $('[data-barre-ajout]', barre);
    if (lienBarre) {
      lienBarre.addEventListener('click', function (e) {
        e.preventDefault();
        var bouton = $('[data-bouton-ajout]');
        if (bouton) bouton.click();
      });
    }
  }

  /* ------------------------------------------------------------------
     7. Apparition au défilement
     ------------------------------------------------------------------ */
  function initApparitions() {
    var cibles = $$('.apparait');
    if (!cibles.length) return;
    if (!('IntersectionObserver' in window)) {
      cibles.forEach(function (el) { el.setAttribute('data-visible', 'true'); });
      return;
    }
    var observateur = new IntersectionObserver(function (entrees, obs) {
      entrees.forEach(function (entree) {
        if (entree.isIntersecting) {
          entree.target.setAttribute('data-visible', 'true');
          obs.unobserve(entree.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    cibles.forEach(function (el) { observateur.observe(el); });
  }

  /* ------------------------------------------------------------------
     8. Hauteur réelle de l'en-tête (pour les éléments collants)
     ------------------------------------------------------------------ */
  function initHauteurEntete() {
    var entete = $('.entete');
    if (!entete) return;
    function mesurer() {
      document.documentElement.style.setProperty('--entete-h', entete.offsetHeight + 'px');
    }
    mesurer();
    window.addEventListener('resize', mesurer);
  }

  /* ------------------------------------------------------------------
     Amorçage
     ------------------------------------------------------------------ */
  function demarrer() {
    initHauteurEntete();
    initTiroir();
    initAccordeons();
    initModales();
    initQuantite();
    initProduit();
    initBarreAchat();
    initApparitions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  /* Rejoue l'initialisation dans l'éditeur de thème Shopify */
  document.addEventListener('shopify:section:load', demarrer);
  document.addEventListener('shopify:section:select', demarrer);
})();
